export default function ChatgptCodeWebsite() {
  return (
    <>
      <h2>Chatgpt Code Website</h2>
      <div>hi</div>
    </>
  );
}
